import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllProductsService = (page = 1, limit = 100) => {
  return HTTP_CLIENT.get(
    `${Endpoint.products.get}?page=${page}&limit=${limit}&sorting=lastest`
  );
};

const SuspendProductService = (id: number) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.products.suspend.replace(":id", id.toString())}`
  );
};

const UnSuspendProductService = (id: number) => {
  return HTTP_CLIENT.patch(
    `${Endpoint.products.unsuspend.replace(":id", id.toString())}`
  );
};

export {
  GetAllProductsService,
  SuspendProductService,
  UnSuspendProductService,
};
